<template>
  <div class="recommend-position">
    <div class="titles flex items-center">
      <span>职位推荐</span>
    </div>

    <div class="list-container">
      <div v-if="bannerList.length" class="flex flex-col">
        <img
          v-for="(banner, index) in bannerList"
          :key="index"
          :src="banner.image"
          alt=""
          class="banner-item"
          @click="clickBannerItem(banner)"
        />
      </div>
      <template v-for="(item, index) in list">
        <CampusItem
          v-if="personInfo.is_student"
          :key="'campus-' + index"
          :campusItemData="item"
          class="job-list-item"
          @clickItem="clickItem"
        />
        <PositionItem
          v-else
          :key="'position-' + index"
          :jobItemData="item"
          class="job-list-item"
          @clickItem="clickItem"
        />
      </template>
    </div>
  </div>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex';
import { get_tUser, getBannerParams } from '@/assets/js/util';
import PositionItem from './PositionItem.vue';
import CampusItem from './CampusItem.vue';

export default {
  name: 'RecommendPosition',
  components: {
    PositionItem,
    CampusItem,
  },
  props: {
    displayType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      jobList: [],
      campusList: [],
      bannerList: [],
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    list() {
      return this.personInfo.is_student ? this.campusList : this.jobList;
    },
  },
  watch: {
    displayType(newVal) {
      if (newVal === 'jobs' && !this.list.length) {
        this.fetchList();
      }
    },
  },
  methods: {
    clickItem(item) {
      if (this.personInfo.is_student) {
        window.open(`/comp_recruit_infos/${item.token}`, '_blank');
      } else {
        window.open(`/jobs/${item.token}.html`, '_blank');
      }
    },
    clickBannerItem(banner) {
      if (!banner.link) return;
      window.open(banner.link, '_blank');
    },
    async fetchRecommendList() {
      const { c_t } = await get_tUser();
      const [res1, res2, res3] = await Promise.all([
        api.recommend.downloadToJob({
          size: 9,
          page: 1,
          resume_token: this.$route.params.token,
          cv_account_token: c_t || '',
        }),
        api.cvsV2.cvsJobsRecommend({
          size: 9,
          from: 0,
          jd_flag: 1,
          resume_token: this.$route.params.token,
          resume_flag: 1,
        }),
        api.jobs.companyListUnlogin({ from: 0, size: 9 }),
      ]);
      if (res1.code === 1000 || res2.code === 1000 || res3.code === 1000) {
        this.jobList =
          (res1?.data?.jobs?.length && res1.data.jobs) ||
          (res2?.data?.jobs?.length && res2.data.jobs) ||
          (res3?.data?.jobs?.length && res3.data.jobs) ||
          [];
      }
    },
    async fetchCampusList() {
      try {
        let params = {
          page: 1,
          size: 9,
          info_type: '不限',
          type: 'recommend',
        };
        let res = await api.jobs.get_recruit_list(params);
        if (res.code === 1000) {
          this.campusList = res.data?.comp_recruit_infos || [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    async fetchList() {
      try {
        const { is_student } = this.personInfo;
        if (is_student) {
          this.fetchCampusList();
        } else {
          this.fetchRecommendList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchBannerList() {
      try {
        const res = await Promise.all([
          api.jobs.getV4Banner(getBannerParams(136)),
          api.jobs.getV4Banner(getBannerParams(137)),
        ]);

        this.bannerList = res
          .filter((item) => item.code === 1000 && item.data?.length)
          .map((value) => value.data[0]);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchList();
    this.fetchBannerList();
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.recommend-position {
  padding: 0 24px;
  width: 100%;
  .titles {
    color: $text-color;
    font-size: 16px;
    font-weight: 600;
  }
  .banner-item {
    height: 104px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    &:first-child {
      margin-top: 16px;
    }
    margin-bottom: 10px;
  }
  .list-container {
    height: calc(100% - 32px);
    overflow-y: scroll;
    width: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
    .job-list-item {
      padding: 20px 24px;
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 10px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 16px;
      }
      &:first-child {
        margin-top: 16px;
      }
    }
  }
}
</style>
